const BASE_URL = 'https://eppxtzix8c.execute-api.ap-south-1.amazonaws.com'
const STAGING_ENDPOINT = `${BASE_URL}/stage`
const SINGLE_PDF_ENDPOINT = 'https://tm-journal.s3.ap-south-1.amazonaws.com'
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  URL: STAGING_ENDPOINT,
  PDF_URL: SINGLE_PDF_ENDPOINT,
}
